var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mailbox-menu" } }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "button",
        { staticClass: "new-email-button", on: { click: _vm.newEmail } },
        [
          _c("span", { staticClass: "new-email-title" }, [
            _vm._v(_vm._s(_vm.$t("mail.newMail"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-form-group",
            {
              staticClass: "form-group-user",
              attrs: {
                label: _vm.$t("mail.mailSelecting"),
                "label-for": "type-input",
              },
            },
            [
              _c(
                "b-form-select",
                {
                  attrs: {
                    id: "type-input",
                    "data-vv-as": _vm.$t("message.contentType"),
                    name: _vm.$t("message.contentType"),
                    type: "text",
                  },
                  model: {
                    value: _vm.selectedMailId,
                    callback: function ($$v) {
                      _vm.selectedMailId = $$v
                    },
                    expression: "selectedMailId",
                  },
                },
                _vm._l(_vm.getUserMailList(), function (getUserMail) {
                  return _c(
                    "option",
                    { domProps: { value: getUserMail._id } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(getUserMail.mail) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "group" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(" " + _vm._s(_vm.$t("mail.myMails")) + " "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "material-icons",
            staticStyle: { "font-size": "16px", cursor: "pointer" },
            on: { click: _vm.integrationMail },
          },
          [_vm._v("\n                settings\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list" }, [
        _c(
          "div",
          {
            staticClass: "item",
            class: [_vm.selectedMenu === "My" && "selected"],
            on: {
              click: function ($event) {
                return _vm.change("My")
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "material-icons",
                staticStyle: { "font-size": "24px" },
              },
              [_vm._v("all_inbox")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "metas" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("mail.inbox"))),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item",
            class: [_vm.selectedMenu === "Sent" && "selected"],
            on: {
              click: function ($event) {
                return _vm.change("Sent")
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "material-icons",
                staticStyle: { "font-size": "24px" },
              },
              [_vm._v("send")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "metas" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("mail.sent"))),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "divider" }),
      _vm._v(" "),
      _vm.departmentMails.length > 0
        ? _c("div", { staticClass: "group" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(" " + _vm._s(_vm.$t("mail.departmentMails")) + " "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "material-icons",
                staticStyle: { "font-size": "16px" },
              },
              [_vm._v("help")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "representative-mails" },
        _vm._l(_vm.departmentMails, function (departmentMail) {
          return _c("div", { staticClass: "list" }, [
            _c(
              "div",
              {
                staticClass: "item",
                class: [
                  _vm.selectedDepartment === departmentMail.mail.mail &&
                    "selected",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changeSelectedDepartment(
                      departmentMail.mail.mail
                    )
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    staticStyle: { "font-size": "24px" },
                  },
                  [_vm._v("person")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "metas" }, [
                  _c(
                    "span",
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.getName(departmentMail.mail))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        { attrs: { title: departmentMail.mail.mail } },
                        [
                          _c(
                            "span",
                            { staticClass: "subtitle department-mail" },
                            [_vm._v(_vm._s(departmentMail.mail.mail))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  departmentMail.count > 0
                    ? _c("span", { staticClass: "unread-count" }, [
                        _vm._v(_vm._s(departmentMail.count)),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "divider" }),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.isVisible()
        ? _c("div", { staticClass: "group" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(" Representative Mails "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "material-icons",
                staticStyle: { "font-size": "16px" },
              },
              [_vm._v("help")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.isAgentMailVisible
        ? _c(
            "div",
            { staticClass: "representative-mails" },
            _vm._l(_vm.visibilityMails, function (visibilityMail) {
              return _c(
                "div",
                {
                  staticClass: "list",
                  on: {
                    click: function ($event) {
                      return _vm.getRepresentativeMail(visibilityMail)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      class: [
                        _vm.selectedRepresentative === visibilityMail._id &&
                          "selected",
                      ],
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "material-icons",
                          staticStyle: { "font-size": "24px" },
                        },
                        [_vm._v("person")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "metas" },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.getNameFix(visibilityMail.user))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-tooltip",
                            { attrs: { title: visibilityMail.mail } },
                            [
                              _c(
                                "span",
                                { staticClass: "subtitle department-mail" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getNameFix(visibilityMail.mail))
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "divider" }),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    false
      ? _c(
          "button",
          {
            staticClass: "new-template-button",
            on: { click: _vm.newTemplate },
          },
          [
            _c("span", { staticClass: "new-template-title" }, [
              _vm._v(_vm._s(_vm.$t("mail.newTemplate"))),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }